import { render, staticRenderFns } from "./RoleEditModal.vue?vue&type=template&id=67d756a0"
import script from "./RoleEditModal.vue?vue&type=script&lang=js"
export * from "./RoleEditModal.vue?vue&type=script&lang=js"
import style0 from "./RoleEditModal.vue?vue&type=style&index=0&id=67d756a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports